import { render } from "./App.vue?vue&type=template&id=c271e5f6&scoped=true&ts=true"
import script from "./app.ts?vue&type=script&lang=ts"
export * from "./app.ts?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=c271e5f6&scoped=true&lang=scss"

import exportComponent from "D:\\ColorMetalBG\\cmportal-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c271e5f6"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QHeader from 'quasar/src/components/header/QHeader.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QHeader,QToolbar,QBtn,QToolbarTitle,QIcon,QBadge,QSelect,QAvatar,QMenu,QInput,QSeparator,QTooltip,QDrawer,QList,QItem,QItemSection,QPageContainer,QBanner});qInstall(script, 'directives', {ClosePopup,Ripple});
